import { Link } from 'react-router-dom';
import { ArrowUpRight, MapPin, Wifi, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { pct } from '../utils/interest';
import { sectorKey } from '../utils/sector';
import { bankInitial } from '../data/bankLogos';

// 지도 옆 금리 목록. 항목을 누르면 가장 가까운 지점으로 지도를 옮깁니다.
export default function ExploreResults({ products, total = 0, offset = 0, onMore, status, collectedAt, term = 12, regionLabel, activeId, onFocus, onHover, onClose }) {
  const { t } = useTranslation();
  return <aside className="rates-panel" aria-label={t('map.results')}>
    <div className="rates-head">
      <div><strong>{t('map.results')}</strong><span>{regionLabel ? `${regionLabel} · ` : ''}{t('map.rateCount', { count: total })} · {term}{t('common.months')}</span></div>
      {onClose && <button className="icon-btn" onClick={onClose} aria-label={t('common.close')}><X size={20}/></button>}
    </div>
    {collectedAt && <div className="rates-sub">{t('common.rateAsOf', { date: collectedAt.slice(0, 10) })} · {t('map.nearbyOnly')}</div>}
    <div className="rates-scroll">
      {status === 'stale' && <div className="empty-result">{t('common.staleRates')}</div>}
      {products.map((p, i) => {
        const active = p.id === activeId;
        return <div key={p.id} className={`rate-item ${active ? 'is-active' : ''}`} onMouseEnter={() => onHover?.(p.branch?.id || null)} onMouseLeave={() => onHover?.(null)}>
          <button className="rate-main" onClick={() => onFocus?.(p)} aria-pressed={active}>
            <span className="rate-rank">{offset + i + 1}</span>
            <span className={`avatar-ring ${p.branch ? '' : 'muted'}`}><span className="avatar">{bankInitial(p.bank)}</span></span>
            <span className="rate-text">
              <span className="rate-bank">{p.bank} · {t(sectorKey(p))}</span>
              <strong>{p.name}{p.branchOnly && <span className="branch-badge">{t('radar.badge')}</span>}</strong>
              <span className="rate-meta">{p.branch ? <><MapPin size={12}/>{p.branch.distanceKm != null && `${p.branch.distanceKm}km · `}{p.branch.name}</> : <><Wifi size={12}/>{t('map.noBranch')}</>}</span>
            </span>
            <span className="rate-value"><b>{pct(p.rate)}</b><small>{t('product.base')} {pct(p.base)}</small></span>
          </button>
          <Link className="rate-detail" to={`/product/${encodeURIComponent(p.id)}`} aria-label={`${p.name} ${t('map.detail')}`} title={t('map.detail')}><ArrowUpRight size={16}/></Link>
        </div>;
      })}
      {offset + products.length < total && <button className="results-more" onClick={onMore}>{t('common.more')}</button>}
      {status === 'error' && <div className="empty-result">{t('common.dataError')}</div>}
      {status === 'loading' && !products.length && <div className="empty-result">{t('common.loading')}</div>}
      {status === 'live' && !total && <div className="empty-result">{t('common.noResults')}</div>}
    </div>
  </aside>;
}
